import { FC } from 'react';
import * as S from './styles';

export interface TappingCopyOptionProps {
  value: string;
  showBigger: boolean;
}

export const TappingCopyOption: FC<TappingCopyOptionProps> = ({ value, showBigger, ...props }) => {
  return (
    <S.Placeholder $showBigger={showBigger} {...props}>
      {value}
    </S.Placeholder>
  );
};
